// extracted by mini-css-extract-plugin
export default {"root":"QRrK8ObzwmGbuLp6ljP7","tag":"CWJkbvb6szs_wSHOfte2"};